import React from "react";
import { PhotoView } from "react-photo-view";
import { useLoaderData } from "react-router-dom";

const ServicesDetailsSection = () => {
  const servicedetail = useLoaderData();
  const { photo, title, description, price, quantity } = servicedetail;
  return (
    <div className="container mx-auto mt-10">
      <div className="w-3/4 mx-auto ">
        <PhotoView src={photo}>
          <img src={photo} alt={title} className={`w-full rounded-xl h-1/2`} />
        </PhotoView>
        <hr className="my-10" />
        <div className="pl-6">
          <h5 className="font-bold text-4xl mt-5">{title}</h5>
          <p className="mt-5">{description}</p>

          <ul className="menu-vertical mt-5 ">
            <li className="">
              <span className="font-bold">Service Cost: </span>
              <span>{price}</span>
            </li>
            <li className="">
              <span className="font-bold">Total Sell: </span>
              <span>{quantity}</span>
            </li>
          </ul>
        </div>
      </div>  
    </div>
  );
};

export default ServicesDetailsSection;
